export default __webpack_public_path__ + "static/jnjBrandingSprite-06d2bb4ce393e0f721f7feae101f45aa.svg";